var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNovuAllNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22578 2C6.03592 2 5.85635 2.08631 5.73774 2.23457L1.92539 7H7.5C7.84518 7 8.125 7.27982 8.125 7.625C8.125 8.66053 8.96447 9.5 10 9.5C11.0355 9.5 11.875 8.66053 11.875 7.625C11.875 7.27982 12.1548 7 12.5 7H18.0746L14.2623 2.23457C14.1437 2.08631 13.9641 2 13.7742 2H6.22578ZM18.667 8.25H13.0625C12.7729 9.6764 11.5118 10.75 10 10.75C8.48815 10.75 7.22706 9.6764 6.93751 8.25H1.33299L1.73331 11.4525C1.7724 11.7653 2.03828 12 2.35348 12H17.6465C17.9617 12 18.2276 11.7653 18.2667 11.4525L18.667 8.25ZM4.76165 1.4537C5.11748 1.00892 5.65619 0.75 6.22578 0.75H13.7742C14.3438 0.75 14.8825 1.00892 15.2383 1.4537L19.863 7.23456C19.9684 7.36632 20.0161 7.53509 19.9952 7.70252L19.507 11.6076C19.3898 12.5459 18.5921 13.25 17.6465 13.25H2.35348C1.40787 13.25 0.610247 12.5459 0.492959 11.6076L0.00482891 7.70252C-0.0160993 7.53509 0.0315554 7.36632 0.13696 7.23456L4.76165 1.4537Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNovuAllNotifications);
export default __webpack_public_path__ + "static/media/ico-novu-all_notifications.dcf12874ac5345a2b4113acb6d33deab.svg";
export { ForwardRef as ReactComponent };